define('components/OneSignal',[
    "jquery",
    "logging"
], function ($, logging) {
    var _ModuleName = "OneSignal";

    var _config = {
        enabled: true,
        sdkUrl: "https://cdn.onesignal.com/sdks/OneSignalSDK.js",
        analytics: {
            category: "Push Notifications",
            action: "Prompt"
        },
        elements: {
            subscribeButton: null
        }
    };

    function Init(scope, config) {
        "use strict";

        // Check if OneSignal plug-in enables custom SDK
        _config.enabled = config.use_custom_sdk_init;
        if (!_config.enabled) {
            ;
            return;
        }

        // The OneSignal plug-in passes all settings to global var window._oneSignalInitOptions
        //;

        // Assign button to config
        _config.elements.subscribeButton = document.querySelector("#get-push-notifications");

        // Initialize OneSignal
        OneSignal.push(function() {
            OneSignal.init({
                appId: config.app_id,
                autoRegister: false,
                autoResubscribe: true,
                notifyButton: {
                    enable: true, // Displays the subscription bell
                },
                welcomeNotification: {
                    title: config.welcome_notification_title,
                    message: config.welcome_notification_message,
                }
            });
            OneSignal.SERVICE_WORKER_UPDATER_PATH = "blogs/" + config.blogname + "/wp-content/plugins/onesignal-free-web-push-notifications/sdk_files/OneSignalSDKUpdaterWorker.js.php";
            OneSignal.SERVICE_WORKER_PATH = "blogs/" + config.blogname + "/wp-content/plugins/onesignal-free-web-push-notifications/sdk_files/OneSignalSDKWorker.js.php";
            OneSignal.SERVICE_WORKER_PARAM = { scope: '/' };
        });

        // Manage user subscriptions
        OneSignal.push(function () {
            // Check if browser supports Push Notifications
            if (!OneSignal.isPushNotificationsSupported()) {
                ;
                return;
            }

            // Set initial state of the prompt based on the user's subscription state.
            _updateSubscriptionPrompt();

            //OneSignal.on("subscriptionChange", function (isSubscribed) {
                // Check for subscription changes during the page session and update the prompt.
                //_updateSubscriptionPrompt();
            //});
        });

        ;
    }

    // Checks if the user's subscription state changed during the session.
    var _updateSubscriptionPrompt = function () {

        _getSubscriptionState().then(function (state) {
            // Verify the prompt and buttons elements exist
            if (_config.elements.subscribeButton === null) {
                return;
            }

            // Subscribe button click event
            _config.elements.subscribeButton.removeEventListener('click', _onSubscribeButtonClicked);
            _config.elements.subscribeButton.addEventListener('click', _onSubscribeButtonClicked);

        });
    }

    // Subscribe button actions
    var _onSubscribeButtonClicked = function (event) {

        _getSubscriptionState().then(function (state) {

            //** New User: isPushEnabled:false && isOptedOut:false
            //** Unsub User: isPushEnabled:false && isOptedOut:true
            //** Sub User: isPushEnabled:true && isOptedOut:false

            if (state.isPushEnabled) {
                // Subscribed, opt them out
                //;
                //OneSignal.setSubscription(false);
            } else {
                if (state.isOptedOut) {
                    // Opted out, opt them back in
                    ;
                    OneSignal.setSubscription(true);

                } else {
                    // Unsubscribed, so subscribe them
                    ;
                    OneSignal.registerForPushNotifications();
                }
            }

        });

        event.preventDefault();
    }

    // Get Users current subscription state
    var _getSubscriptionState = function () {
        return Promise.all([
          OneSignal.isPushNotificationsEnabled(),
          OneSignal.isOptedOut(),
          OneSignal.getNotificationPermission()
        ]).then(function (result) {
            var isPushEnabled = result[0];
            var isOptedOut = result[1];
            var isAllowingNotifications = result[2];

            ;
            ;
            ; // 'default', 'granted', or 'denied'

            return {
                isPushEnabled: isPushEnabled,
                isOptedOut: isOptedOut,
                isAllowingNotifications: isAllowingNotifications
            };
        });
    }


    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new Init(args.scope, args.Config);
        }
    }
});
